import PropTypes from 'prop-types'

import { truncate } from 'utils/strings'

import { NavLink } from 'react-router'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'
import { MEGA_MENU_LINE_LENGTH } from 'constants/constants'

export const LinkStyles = css`
  color: ${colors.secondary40};
  padding: 8px 7px;
  text-decoration: none;
  display: block;
  font-size: 14px;
  line-height: 16px;
  transition: all .25s linear;
  white-space: nowrap;
  border-bottom: 1px solid ${colors.secondary95};
  cursor: pointer;
  position: relative;
  &.active, &:active, &:hover, &:focus {
    color: ${colors.secondary20};
  }
  &.active {
    background-color: ${colors.primary80};
  }
  &:hover, &:focus {
    background-color: ${colors.primary90};
  }
  &:active {
    background-color: ${colors.primary80};
  }
  border-bottom: 1px solid ${colors.secondary95};
`

const StyledMegaMenuLink = styled(NavLink)`
  ${LinkStyles}
`
const MegaMenuLink = ({ name, to, innerRef, target, subMenuId, icon }) => {
  return (
    <StyledMegaMenuLink
      to={to}
      ref={innerRef}
      target={target}
      onMouseEnter={(e) => e.currentTarget.focus()}
      onMouseOut={(e) => e.currentTarget.blur()}
      tabIndex={0}
      data-test='megamenu-link'
    >
      {truncate(name, MEGA_MENU_LINE_LENGTH)}
    </StyledMegaMenuLink>
  )
}

MegaMenuLink.propTypes = {
  name: PropTypes.string.isRequired,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  target: PropTypes.string,
  subMenuId: PropTypes.string,
  icon: PropTypes.string,
}

export default MegaMenuLink
